<div class="flex flex-col gap-2">
  @if (config()?.showSize) {
    <div class="flex flex-col gap-0.5 w-full">
      <span class="text-white self-start">{{ 'EDITOR.CONTROLS.SIZE' | translate }}: {{ size }}</span>
      <lib-slider
        class="w-full"
        variant="primary"
        [min]="1"
        [max]="9"
        [step]="1"
        [value]="size"
        (changed)="onSizeChanged($event)" />
    </div>
  }

  @if (config()?.showSigma) {
    <div class="flex flex-col gap-0.5 w-full">
      <span class="text-white self-start">{{ 'EDITOR.CONTROLS.SIGMA' | translate }}: {{ sigma }}</span>
      <lib-slider
        class="w-full"
        variant="primary"
        [min]="1"
        [max]="20"
        [step]="1"
        [value]="sigma"
        (changed)="onSigmaChanged($event)" />
    </div>
  }

  @if (config()?.showAngle) {
    <div class="flex flex-col gap-0.5 w-full">
      <span class="text-white">{{ 'EDITOR.CONTROLS.ANGLE' | translate }}: {{ angle }}</span>
      <lib-slider
        class="w-full"
        variant="primary"
        [min]="0"
        [max]="180"
        [step]="1"
        [value]="angle"
        (changed)="onAngleChanged($event)" />
    </div>
  }
</div>
